<template>
  <div>
    <div class="filters">
      <div class="flex">
        <div class="filter-item">
          <span>时间选择：</span>
          <el-date-picker
            v-model="dateRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :clearable="false"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="chooseDate"
          >
          </el-date-picker>
        </div>
        <!-- <div class="filter-item">
          <span>交易类型：</span>
          <el-select v-model="dataType" placeholder="请选择">
            <el-option label="收入" value="income" />
            <el-option label="支出" value="expend" />
          </el-select>
        </div> -->
        <!-- <div class="filter-item">
          <span></span>
          <el-input v-model="inputOrder" placeholder=""></el-input>
        </div> -->
      </div>
      <div>
        <el-button type="primary" plain icon="el-icon-search" size="small" class="search-btn" @click="getOrderInfo">查询</el-button>
        <!-- <el-button type="warning" style="border-radius: 14px" icon="el-icon-s-flag" plain @click.stop="hitMark">打标记</el-button>
        <el-button type="success" plain icon="el-icon-zoom-in" size="small" class="search-btn" @click="getBasicInfo">拉取订单状态</el-button> 
        <el-button type="danger" style="border-radius: 14px" icon="el-icon-delete" plain @click.stop="removeOrder"> 删除订单</el-button> 
        <el-button type="warning" style="border-radius: 14px" icon="el-icon-refresh-left" plain @click.stop="cancleOrder">撤销订单状态</el-button> -->
      </div>
    </div>
    <el-table
      :show-header="false"
      :data="tableData"
      v-loading="laodTable"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
      height="calc(100vh - 350px)"
      class="balance-table"
    >
      <el-table-column>
        <template slot-scope="scope">
          <div class="item-box">
            <div class="item-icon">
              <img src="https://picture.aiyizhijian.com/image/png/647282196386088192.png" alt="" style="width: 100%; height: 100%" />
            </div>
            <div class="item-text">
              <div class="big bold">
                订单编号: <span style="color: #2d99d7">{{ scope.row.DocumentNo }}</span>
              </div>
              <div class="small">
                {{ scope.row.orsl_Consumer_name }}/{{ scope.row.orsl_Consumer_gender }}/{{ scope.row.orsl_Consumer_age }}/{{
                  scope.row.orsl_Consumer_mobile_number
                }}
              </div>
              <div class="small">{{ scope.row.Creationtime }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="100" prop="orsl_Clearing_mark">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.orsl_Clearing_mark === '未清账'" type="warning">月结未清账</el-tag>
        </template>
      </el-table-column>
      <el-table-column width="120" prop="orsl_Order_type">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.orsl_Order_type === '冲红订单'" type="warning">冲红订单</el-tag>
          <!-- <el-tag v-if="scope.row.orsl_Order_type !== '冲红订单'" type="success">常规订单</el-tag> -->
        </template>
      </el-table-column>
      <el-table-column width="120" prop="orsl_Report_status">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.orsl_Report_status === '报告已出'" type="success">报告已出</el-tag>
          <el-tag v-if="scope.row.orsl_Report_status === '部分已出'" type="warning">部分已出</el-tag>
          <el-tag v-if="scope.row.orsl_Report_status === ''" type="danger">报告未出</el-tag>
        </template>
      </el-table-column>

      <el-table-column width="100" prop="orsl_Payment_status">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.orsl_Payment_status === '已结算'" type="success">已结算</el-tag>
          <el-tag v-if="scope.row.orsl_Payment_status !== '已结算'" type="warning">{{scope.row.orsl_Payment_status?scope.row.orsl_Payment_status:'未结算'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column width="100" prop="state">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state === '已填写'" type="success">{{ scope.row.state }}</el-tag>
          <el-tag v-if="scope.row.state !== '已填写'" type="info">{{ scope.row.state ? scope.row.state : '未填写' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column width="100" prop="orsl_Use_balance">
        <template slot-scope="scope">
          <div class="big bold text-color-success" v-if="scope.row.orsl_Use_balance < 0">+{{ -1 * scope.row.orsl_Use_balance }}</div>
          <div class="big bold text-color-danger" v-if="scope.row.orsl_Use_balance >= 0">
            {{ -1 * scope.row.orsl_Use_balance }}
          </div>
          <div class="small">账户余额</div>
        </template>
      </el-table-column>
      <el-table-column width="100" prop="orsl_Using_points">
        <template slot-scope="scope">
          <div class="big bold text-color-success" v-if="scope.row.orsl_Using_points < 0">+{{ -1 * scope.row.orsl_Using_points }}</div>
          <div class="big bold text-color-danger" v-if="scope.row.orsl_Using_points >= 0">
            {{ -1 * scope.row.orsl_Using_points }}
          </div>
          <div class="small">E豆</div>
        </template>
      </el-table-column>
      <el-table-column width="100" prop="orsl_Using_wechat">
        <template slot-scope="scope">
          <!-- <div class="big bold text-color-success">
            {{ scope.row.orsl_Using_wechat }}
          </div> -->
          <div class="big bold text-color-success" v-if="scope.row.orsl_Using_wechat < 0">+{{ -1 * scope.row.orsl_Using_wechat }}</div>
          <div class="big bold text-color-danger" v-if="scope.row.orsl_Using_wechat >= 0">
            {{ -1 * scope.row.orsl_Using_wechat }}
          </div>
          <div class="small">微信</div>
        </template>
      </el-table-column>
      <el-table-column type="expand" width="50">
        <template slot-scope="props">
          <div>
            检测项目： <span v-for="(item2, index2) in props.row.Order_detail_Library" :key="index2">{{ item2.psl_name }};</span>
          </div>
          <div>
            条码： <span v-for="item in props.row.Order_detail_barcode" :key="item.id">{{ item.orcab_barcode }};</span>
          </div>
          <div>
            订单备注：<span>{{ props.row.orsl_remarks }}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import request from '@/utils/request';
import moment from 'moment';
export default {
  name: 'BanlanceTable',
  data() {
    return {
      inputOrder: '',
      dateRange: [],
      dataType: '',
      startTime: '', //左侧时间
      endTime: '', //右侧时间
      tableData: [],
      laodTable: false
    };
  },
  filters: {
    sexFilter(val) {
      return val === 'male' ? '男' : val === 'female' ? '女' : '未知';
    }
  },
  created() {},
  mounted() {
    this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD');
    // this.startTime = moment(new Date().getTime() - 1000 * 60 * 60 * 24).format('YYYY-MM-DD');
    this.startTime = moment(new Date().getTime()).format('YYYY-MM-DD');
    this.dateRange = [this.startTime, this.endTime];
    this.getOrderInfo();
  },
  methods: {
    removeOrder() {
      const that = this;
      if (!that.inputOrder) {
        that.$message.error('抱歉，请填入订单号');
        return false;
      }
      const clinicInfo = JSON.parse(sessionStorage.user);
      // that
      //   .$confirm('确定要删除此订单吗？', '提示', {
      //     type: 'warning'
      //   })
      //   .then(() => {
      let dataP = {
        DocumentNo: that.inputOrder,
        cal_code: clinicInfo.cal_code
      };
      const params = {
        token: clinicInfo.token,
        workid: 'a5c8b816-7a6b-74c0-eadf-0e1fb362f82d',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          if (res.delOrder_detail_Library.IsOk === 'success') {
            that.$message.success('恭喜，删除订单成功');
          } else {
            that.$message.error('抱歉，删除订单失败');
          }
        })
        .catch((err) => {});
      // })
      // .catch(() => {
      //   that.$message.info('已取消删除');
      // });
    },
    // 获取订单详情
    getBasicInfo(){
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        DocumentNo: that.inputOrder
      };
      const params = {
        token: clinicInfo.token,
        workid: '11792016-5732-aa16-76fa-66b1a1d3dca1',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {       
          const orderStorage = res.Order_summary_Library[0];    
          console.log('订单详情：：：', orderStorage);
        })
        .catch((err) => {
          
        });
    },
    // 打标记
    hitMark(){
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        DocumentNo: that.inputOrder
      };
      const params = {
        token: clinicInfo.token,
        userurl: 'https://cloud.hwason.cn/',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/weixinpayddsettlement.php', params)
        .then((res) => {
          console.log('微信支付后回调', res);
        })
        .catch((err) => {});
    },
    // 撤销支付状态
    cancleOrder() {
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        DocumentNo: that.inputOrder
      };
      const params = {
        token: clinicInfo.token,
        workid: '54c54a4e-bf2f-cfaf-987e-7c56fc770d98',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          console.log(res, '4444');
          // console.log('撤销支付状态成功');
        })
        .catch((err) => {});
    },

    // 选择时间
    chooseDate(event) {
      if (event) {
        this.startTime = event[0];
        this.endTime = event[1];
        this.getOrderInfo();
      } else {
        this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD');
        this.startTime = moment(new Date().getTime() - 1000 * 60 * 60 * 24).format('YYYY-MM-DD');
        this.getOrderInfo();
      }
    },
    // 获取订单明细
    getOrderInfo() {
      const that = this;
      that.laodTable = true;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        cal_code: clinicInfo.cal_code,
        ksdate: that.startTime,
        jsdate: that.endTime
      };
      const params = {
        token: clinicInfo.token,
        workid: '5cbad6e1-ed74-e6ec-e959-bfd086780d8c',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          // that.tableData = res.Order_summary_Library;
          that.tableData = res.Order_summary_Library.filter((val) => val.orsl_Consumer_name);
          that.laodTable = false;
          // console.log('1111:', that.tableData);
        })
        .catch((err) => {
          that.laodTable = false;
          that.$message.error('抱歉，收支明细列表查询失败');
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.balance-table {
  width: 100%;
  // border: 1px solid red;
}
.filters {
  display: flex;
  margin-bottom: 15px;
  .el-date-editor {
    width: 240px;
  }
  .el-select {
    width: 120px;
  }
  .filter-item {
    margin-right: 10px;
  }
}
.item-box {
  display: flex;
  .item-icon {
    width: 50px;
    height: 50px;
    flex-shrink: 0;
    border-radius: 10px;
    // background-color: #5db4fc;
    margin-right: 10px;
    // background-size: 30px;
    // background-repeat: no-repeat;
    // background-position: center center;
    // background-image: url(~@/assets/img/shiguan.svg);
  }
  .item-text {
    line-height: 14px;
    .bold {
      line-height: 20px;
    }
  }
}
</style>
